<app-toggle-group
    [options]="[
        { label: 'tabs.documents' | t, value: 'documents' },
        {
            label: 'tabs.hyperlinks' | t,
            value: 'hyperlinks',
            count: model.hyperlinks.length,
        },
    ]"
    [(selectedValue)]="selectedTab"
>
</app-toggle-group>

@switch (selectedTab) {
    @case ("documents") {}
    @case ("hyperlinks") {
        <app-asset-hyperlinks
            [model]="model"
            [canEdit]="canEdit"
            (hyperlinksChanged)="hyperlinksChanged.emit($event)"
        ></app-asset-hyperlinks>
    }
}
